// Regular weights
import CalibreThin from './Calibre-Thin.woff2';
import CalibreLight from './Calibre-Light.woff2';
import CalibreRegular from './Calibre-Regular.woff2';
import CalibreMedium from './Calibre-Medium.woff2';
import CalibreSemibold from './Calibre-Semibold.woff2';
import CalibreBold from './Calibre-Bold.woff2';
import CalibreBlack from './Calibre-Black.woff2';

// Italic weights
import CalibreThinItalic from './Calibre-ThinItalic.woff2';
import CalibreLightItalic from './Calibre-LightItalic.woff2';
import CalibreRegularItalic from './Calibre-RegularItalic.woff2';
import CalibreMediumItalic from './Calibre-MediumItalic.woff2';
import CalibreSemiboldItalic from './Calibre-SemiboldItalic.woff2';
import CalibreBoldItalic from './Calibre-BoldItalic.woff2';
import CalibreBlackItalic from './Calibre-BlackItalic.woff2';

export const Calibre = {
    // Regular weights (backward compatible)
    Thin: CalibreThin,
    Light: CalibreLight,
    Regular: CalibreRegular,
    Medium: CalibreMedium,
    Semibold: CalibreSemibold,
    Bold: CalibreBold,
    Black: CalibreBlack,

    // Italic weights
    ThinItalic: CalibreThinItalic,
    LightItalic: CalibreLightItalic,
    RegularItalic: CalibreRegularItalic,
    MediumItalic: CalibreMediumItalic,
    SemiboldItalic: CalibreSemiboldItalic,
    BoldItalic: CalibreBoldItalic,
    BlackItalic: CalibreBlackItalic,
};
